export interface DealLike {
  jobNumber: string | null;
  title: string;
}

// Strip a leading "9453 - " / "9453- " / "9453 " from a title when it
// duplicates the job number shown alongside it.
export function stripJobPrefix(jobNumber: string | null, title: string): string {
  const trimmed = title.trim();
  if (!jobNumber) return trimmed;
  const dup = new RegExp(`^${jobNumber}\\s*-?\\s*`);
  return trimmed.replace(dup, '').trim();
}

export function dealLabel(d: DealLike): string {
  const job = d.jobNumber;
  const title = stripJobPrefix(job, d.title);
  return `${job ?? '—'} — ${title}`;
}
